import { MentionConfig } from '@design-system/components/markdownEditor';

const MENTION_TOKENS = ['@channel', '@community'] as const;

export const COMMUNITY_MENTION = '@community';

export const communityMentionConfig: MentionConfig = {
  recognizedTokens: MENTION_TOKENS,
  insertToken: COMMUNITY_MENTION,
  menuTitle: COMMUNITY_MENTION,
  menuSubtitle: 'Notify everyone in the community',
};

export const containsCommunityMention = (text: string): boolean =>
  /@community/i.test(text);

export type MentionTextPart = {
  text: string;
  isMention: boolean;
};

const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const splitTextByChannelMention = (
  text: string,
  mentionNames: string[] = [],
): MentionTextPart[] => {
  const tokens = [
    ...MENTION_TOKENS,
    ...mentionNames.filter(Boolean).map((name) => `@${name}`),
  ].sort((a, b) => b.length - a.length);
  const mentionRegex = new RegExp(tokens.map(escapeRegExp).join('|'), 'g');

  if (!mentionRegex.test(text)) {
    return [{ text, isMention: false }];
  }

  const parts: MentionTextPart[] = [];
  let lastIndex = 0;
  let match;

  mentionRegex.lastIndex = 0;
  while ((match = mentionRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({
        text: text.slice(lastIndex, match.index),
        isMention: false,
      });
    }

    parts.push({
      text: match[0],
      isMention: true,
    });

    lastIndex = mentionRegex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push({
      text: text.slice(lastIndex),
      isMention: false,
    });
  }

  return parts;
};
